export default "__VITE_ASSET__74d9e126__"